/** Hours either side of the requested time the finder searches */
export const FinderSearchWindowHours = 2

/** Restaurants per finder search (the API caps it at 20) */
export const FinderResultLimit = 20

/** Time chips on a finder card */
export const FinderTimeChipCount = 3

export const BookingPartySizeLimit = {
  Min: 1,
  Max: 20,
}

export const DefaultFinderPartySize = 2

export const DefaultFinderTime = '19:00'

/** Cities the finder's empty state suggests */
export const FinderSuggestedCities = ['Stockholm', 'Göteborg']

/** Error codes meaning the held seating is gone and a new time is needed */
export const HoldLostErrorCodes = [
  'reservation-unavailable',
  'reservation-hold-ended',
]

/** How often, and how many times, a submitted booking is read until it settles */
export const ConfirmationPoll = {
  IntervalMs: 1000,
  Attempts: 5,
}

/** Bookings My visits shows, newest first (the API allows up to 100) */
export const MyVisitsLimit = 50
